/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const leaf_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.232 11.555c-3.577.995-6.767 2.817-9.574 5.239M1 19.09l2.658-2.296m0 0a7.45 7.45 0 0 0 1.422 2.023A7.32 7.32 0 0 0 10.286 21c6.183 0 14.325-6.389 12.436-17.582a.5.5 0 0 0-.534-.416.452.452 0 0 0-.227.09C15.774 8.288 2.923 2.741 2.923 13.548c0 1.135.256 2.243.735 3.246Z"
    />
  </svg>
)
export default leaf_medium
